export default "__VITE_ASSET__N_vMZF0g__"